/** @type {number} */
let headerHeight

/**
 * Find out how much of the window height is occupied by the header.
 * @returns {number} Height of the #page-header element in px
 */
export default function getHeaderHeight() {
    // Header height doesn't change
    if (headerHeight) return headerHeight
    headerHeight = document.getElementById('page-header').clientHeight
    return headerHeight
}
